import React from 'react'
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { generateDataLabelPluginConfig } from '../../utils/Config/DataLabelPluginConfig';

const BarChartProjectReport = ({ chart }) => {
    const { t } = useTranslation();

    const maxValue = Math.max(
        ...chart.map((item) => Math.max(item.disbursed, item.projected))
    );
    const roundedMaxValue = Math.ceil(maxValue / 1000000) * 1000000;

    const disbursedDataSource = chart.map((item) => item.disbursed);

    const data = {
        labels: chart.map((item) => item.year),
        datasets: [
            {
                label: t('amount_disbursed'),
                type: "bar",
                data: disbursedDataSource,
                backgroundColor: "#538cff",
                borderColor: "#538cff",
                borderWidth: 2,
                order: 2,
                barThickness: 15,
                barPercentage: 0.1,
                categoryPercentage: 0.5,
                datalabels: {
                    display: false
                }
            },
            {
                label: t('original_projection'),
                type: "line",
                data: chart.map((item) => item.projected),
                borderColor: "grey",
                pointBackgroundColor: "white",
                borderWidth: 3,
                fill: false,
                pointRadius: 6,
                lineTension: 0,
                barPercentage: 0.1,
                categoryPercentage: 0.5,
                order: 1
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        devicePixelRatio: 3,
        layout: {
            padding: { bottom: 10, top: 8 }
        },
        plugins: {
            datalabels: {
                display: true,
                align: 'right',
                anchor: 'start',
                formatter: (value: number) => `${(value / 1000000).toFixed(1)} MM`,
                color: '#000',
                font: {
                    size: 12,
                    weight: 300,
                },
            },
        },
        scales: {
            xAxes: [
                {
                    gridLines: { display: false },
                    ticks: { fontSize: 15 }
                },
            ],
            yAxes: [
                {
                    scaleLabel: {
                        display: true,
                        labelString: t('millions_word') + ' ' + t('dolar_sign'),
                        position: 'top',
                        padding: 10,
                    },
                    gridLines: { display: true },
                    ticks: {
                        fontSize: 15,
                        beginAtZero: true,
                        stepSize: Math.ceil(roundedMaxValue / 10),
                        min: 0,
                        max: roundedMaxValue,
                        callback: (value: number) => value / 1000000,
                    },
                },
            ],
        },
        legend: {
            display: false
        }
    };

    const customLabelsPlugin = generateDataLabelPluginConfig(disbursedDataSource);

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            minHeight: 0,
            minWidth: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden"
        }}>
            <Bar data={data} options={options} plugins={[customLabelsPlugin]} />
        </div>
    );
};

export default BarChartProjectReport;

